// WHY: Blob エラーは interceptor で正規化されないため、BE の message と HTTP status を持ち回る（status は onError の 401/403 分岐に使う）
export class ShipmentCsvDownloadError extends Error {
  constructor(
    message: string,
    readonly httpStatus?: number
  ) {
    super(message)
    this.name = 'ShipmentCsvDownloadError'
  }
}
